
(function () {
    if (!App.H.hasClass('page-career')) {return false;}

    let $vacancyWrapper = $('.js-vacancy-wrapper');
    let $vacancyItems = $('.js-vacancy-item');
    let $vacancyShowAll = $('.js-vacancy-show-all');
    let maxItems = parseInt($vacancyWrapper.data('max-items'));

    if ($vacancyItems.length < maxItems) {
        $vacancyShowAll.hide();
    } else {
        $vacancyItems.each(function (index, el) {
            if (index >= $vacancyWrapper.data('max-items')) {
                $(el).addClass('_hidden');
            }
        });
    }

    /* Показать все вакансии */
    $vacancyShowAll.on('click', function (e) {
        let needBtnText = !$vacancyShowAll.hasClass('_toggle') ? $vacancyShowAll.data('replace') : $vacancyShowAll.data('default');

        $vacancyShowAll.toggleClass('_toggle');
        $vacancyShowAll.html(needBtnText);

        if ($vacancyShowAll.hasClass('_toggle')) {
            $vacancyItems.filter('._hidden').toggleClass('_hidden _toggled');
        } else {
            $vacancyItems.filter('._toggled').toggleClass('_hidden _toggled');
        }

        e.preventDefault();
    });

})();

export function setNeedVacancy(_type) {
    let $vacSeelect = $('.js-vacancy-type');
    let currIndex = $vacSeelect.find(`option[data-vacancy=${_type}]`).data('index');

    $vacSeelect.closest('.js-pseudo-select').find(`.js-pseudo-select-item[data-index=${currIndex}]`).trigger('click');
}



// WEBPACK FOOTER //
// ./_src/js/modules/PageVacancy.js